import React from "react";
import { Button, Form, Row, Col, Card } from "react-bootstrap";
import { FaPlus, FaTrash, FaTimes, FaSave, FaListUl } from "react-icons/fa";

const LookupFormView = ({
  editingId,
  groupName,
  setGroupName,
  items,
  handleItemChange,
  handleRemoveItem,
  handleAddItem,
  handleSave,
  resetForm
}) => {
  return (
    <Card className="lookup-card-main bg-dark border-secondary text-white">
      <Card.Body>
        <div className="d-flex justify-content-between align-items-center mb-4">
          <div>
            <h3>
              {editingId ? "Edit Lookup Group" : "Add Lookup Group"}
            </h3>
            <p className="text-muted small mb-0">
              Define and manage system-wide dropdown constants.
            </p>
          </div>
          <Button variant="secondary" onClick={resetForm}>
            <FaTimes className="me-2" />
            Cancel
          </Button>
        </div>

        <Row className="mb-4">
          <Col md={6}>
            <Form.Label>Group Identifier</Form.Label>
            <Form.Control
              className="bg-dark text-white border-secondary"
              value={groupName}
              onChange={(e) => setGroupName(e.target.value)}
              placeholder="e.g. skinType"
              disabled={!!editingId}
            />
            <small className="text-muted mt-1 d-block">
              Used internally to fetch these options.
            </small>
          </Col>
        </Row>

        <h6 className="mt-5 mb-3">
          <FaListUl className="me-2" />
          Row Entries
        </h6>

        <div className="items-container mb-4">
          {items.map((item, index) => (
            <Row key={index} className="mb-3 g-2 align-items-center">
              <Col md={5}>
                <Form.Control
                  className="bg-dark text-white border-secondary"
                  placeholder="Value"
                  value={item.value}
                  onChange={(e) =>
                    handleItemChange(index, "value", e.target.value)
                  }
                />
              </Col>
              <Col md={5}>
                <Form.Control
                  className="bg-dark text-white border-secondary"
                  placeholder="Label"
                  value={item.label}
                  onChange={(e) =>
                    handleItemChange(index, "label", e.target.value)
                  }
                />
              </Col>
              <Col md={2}>
                {items.length > 1 && (
                  <Button
                    variant="danger"
                    size="sm"
                    onClick={() => handleRemoveItem(index)}
                  >
                    <FaTrash />
                  </Button>
                )}
              </Col>
            </Row>
          ))}

          <Button
            variant="outline-info"
            size="sm"
            onClick={handleAddItem}
          >
            <FaPlus className="me-1" />
            Add Row
          </Button>
        </div>

        <div className="d-flex justify-content-between align-items-center border-top border-secondary pt-4 mt-5">
          <Button variant="secondary" onClick={resetForm}>
            DISCARD
          </Button>
          <Button variant="primary" onClick={handleSave}>
            <FaSave className="me-2" />
            SAVE
          </Button>
        </div>
      </Card.Body>
    </Card>
  );
};

export default LookupFormView;
